let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hUeST")).then(() => parcelRequire('og1G8'));